export const TIMEZONE_OFFSETS = [
  { value: "-12:00", zone: "Etc/GMT+12", label: "Baker Island" },
  { value: "-11:00", zone: "Pacific/Pago_Pago", label: "Samoa" },
  { value: "-10:00", zone: "Pacific/Honolulu", label: "Hawaii" },
  { value: "-09:00", zone: "America/Anchorage", label: "Alaska" },
  { value: "-08:00", zone: "America/Los_Angeles", label: "Pacific" },
  { value: "-07:00", zone: "America/Denver", label: "Mountain" },
  { value: "-06:00", zone: "America/Chicago", label: "Central" },
  { value: "-05:00", zone: "America/New_York", label: "Eastern" },
  { value: "-04:00", zone: "America/Halifax", label: "Atlantic" },
  { value: "-03:00", zone: "America/Sao_Paulo", label: "Brazil" },

  { value: "+00:00", zone: "UTC", label: "UTC" },
  { value: "+01:00", zone: "Europe/Berlin", label: "CET (Central European Time)" },
  { value: "+02:00", zone: "Europe/Berlin", label: "CEST (Central European Summer Time)" },
  { value: "+03:00", zone: "Europe/Moscow", label: "Russia" },
  { value: "+04:00", zone: "Asia/Dubai", label: "Gulf" },
  { value: "+05:00", zone: "Asia/Karachi", label: "Pakistan" },
  { value: "+05:30", zone: "Asia/Kolkata", label: "India" },
  { value: "+06:00", zone: "Asia/Dhaka", label: "Bangladesh" },
  { value: "+07:00", zone: "Asia/Bangkok", label: "Thailand" },
  { value: "+08:00", zone: "Asia/Shanghai", label: "China" },
  { value: "+09:00", zone: "Asia/Tokyo", label: "Japan" },
  { value: "+10:00", zone: "Australia/Sydney", label: "Australia" },
  { value: "+11:00", zone: "Pacific/Noumea", label: "New Caledonia" },
  { value: "+12:00", zone: "Pacific/Auckland", label: "New Zealand" }
];
